import { defineLocalStore } from '@/utils/localStore'
import { computed, reactive } from 'vue'
import { useRoute } from 'vue-router'
import { handleAsync } from 'best-modules/plugins'
import { useBreadcrumb } from '@/plugins'
import { getPersonName } from 'best-modules/utils'
import { userDelegationSingle, userDelegationSummary } from '@/requests/user'

export const { initLocalStore: initDelegation, useLocalStore: useDelegation } =
  defineLocalStore('delegation', () => {
    const route = useRoute()
    const breadcrumb = useBreadcrumb()

    const delegationId = computed<number>(() => Number(route.params.id))

    const delegation = reactive<Record<string, any>>({})
    const summary = reactive({
      agreements: 0,
      signatures: 0,
    })

    const getDelegation = () => {
      return handleAsync('getDelegation', async () => {
        const [data, sum] = await Promise.all([
          userDelegationSingle(delegationId.value),
          userDelegationSummary(delegationId.value),
        ])

        Object.assign(delegation, data)
        Object.assign(summary, sum)

        breadcrumb.set([
          {
            index: 1,
            title: getPersonName(data.user, { initials: true }),
            disabled: true,
          },
        ])
      })
    }

    getDelegation()

    return { delegationId, delegation, summary }
  })
